<template>
  <b-card-body>
    <h5>{{ $t('question') }}</h5>
    <b-row>
      <b-col v-for="(image, imageIndex) in question.images" :key="imageIndex" lg="1" style="padding: 0px; margin-left: 15px; margin-bottom: 15px; min-width: 150px;">
        <b-card>
          <b-row>
            <b-col>
              <b-img :src="image.imageUrl" fluid alt="" center />
            </b-col>
          </b-row>
          <b-row align-h="center">
            <b-button class="fa fa-plus modalButton" variant="primary"
                      @click.stop="$emit('showImageBank', image)" />
            <b-button class="fa fa-trash modalButton" variant="danger"
                      @click.stop="deleteObjectFromCollection(question.images, imageIndex)" />
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-button class="addButton" style="margin-top: 5px;" @click.stop="addImage(question.images)">
          {{ $t('privatePage.scaleQuestionsAlternativeAdd') }}
        </b-button>
      </b-col>
    </b-row>

    <h5 style="margin: 35px 0px 15px 0px">{{ $t('questionalternative') }}</h5>

    <b-row>
      <b-col v-for="(alternative, alternativeIndex) in question.alternatives" :key="alternativeIndex" lg="1" style="padding: 0px; margin-left: 15px; margin-bottom: 15px; min-width: 150px;">
        <b-card>
          <input :id="`alternative-${alternative.questionAlternativeId}`" class="me-2" type="checkbox" :checked="alternative.points > 0" :value="1" @change="e => onSelectAlternative(e, alternative)" />
          <label :for="`alternative-${alternative.questionAlternativeId}`">
            {{ $t('privatePage.scaleQuestionsAnswer') }}
          </label>
          <b-row>
            <b-col style="margin-top:10px;">
              <b-img :src="alternative.imageUrl" fluid alt="" center />
            </b-col>
          </b-row>
          <b-row align-h="center">
            <b-button class="fa fa-plus modalButton" variant="primary"
                      @click.stop="$emit('showImageBank', alternative)"/>
            <b-button class="fa fa-trash modalButton" variant="danger"
                      @click.stop="deleteObjectFromCollection(question.alternatives, alternativeIndex)"/>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-button class="addButton me-2" style="margin-top: 5px;" @click.stop="addAlternative(question.alternatives)">
          {{ $t('privatePage.scaleQuestionsAlternativeAdd') }}
        </b-button>

        <b-button ref="deleteQuestionButton"
              variant="danger"
              style="margin-top: 5px;"
              v-if="isPartOfCollection"
              @click.stop="$emit('onDeleteQuestion', questionIndex)">
            {{ $t('privatePage.scaleQuestionsDelete') }}
        </b-button>
      </b-col>
    </b-row>
  </b-card-body>
</template>

<script>
import editorFuncs from '../questioneditorfuncs'

export default {
  name: 'gfig-module',
  data() {
    return {
      imageCount: 0
    }
  },
  props: {
    question: {},
    questionIndex: 0,
    isPartOfCollection: false
  },
  methods: {
    deleteObjectFromCollection(collection, index) {
      editorFuncs.deleteObjectFromCollection(collection, index)
    },
    addAlternative() {
      editorFuncs.addAlternative(
        this.question.alternatives
      )
    },
    addImage(images) {
      images.push({
        id: '',
        imageUrl: '',
        orderNum: ++this.imageCount
      })
    },
    onSelectAlternative(event, selected) {
      const value = event.target.value
      const checked = event.target.checked
      if (checked) {
        selected.points = value
      } else {
        selected.points = 0
      }
    }
  },
  created() {
    if (this.question.alternatives.length === 0) {
      this.addAlternative()
      this.addImage(this.question.images)
    } else {
      this.question.images.forEach(image => {
        this.imageCount =
          image.orderNum > this.imageCount ? image.orderNum : ++this.imageCount
      })
    }
  }
}
</script>

<style scoped>
.modalButton {
  margin: 15px 0px 15px 0px;
}
.addButton {
  margin-top: 15px;
}
</style>
